// ═══════════════════════════════════════════════════════════════════
// fieldLayout3D.js — the Shatterfield's SEAT LAYOUT (3D)
// ═══════════════════════════════════════════════════════════════════
// This is the card game's BOARD_SPACES: the ONLY hand-authored spatial
// data in the 3D conversion. Everything else derives from it.
//
// Coordinates are MY seat's coordinates. The opponent's side renders
// inside <group rotation={[0, Math.PI, 0]}> which maps (x, z) → (−x, −z)
// automatically — one layout, two seats, zero mirroring math.
//
// Axes: +z toward my camera, +x to my right, y up. Seam at z = 0.
// ═══════════════════════════════════════════════════════════════════

// One card's physical body (world units). W×H is the classic 5:7 ratio.
export const CARD = { W: 1.0, H: 1.4, T: 0.035 };

// The table plate the whole duel sits on.
export const TABLE = { W: 13.2, D: 8.6 };

// ── Y-ELEVATION TABLE (z-fighting law — keep every layer unique) ──
//   table plate        0.000
//   rift pad           0.006
//   seam line          0.010
//   lying card         0.006 + T/2 (stacks add T + 0.004 each)
//   sigil ornament     0.060
export const Y = {
  pad: 0.006,
  seam: 0.010,
  card: 0.006,
  stackGap: 0.004,
};

// ── SEAT LAYOUT — one side of the Shatterfield ──
// Front row: the four Escling rifts (beings). Back row: Tome rifts.
// Left wing: Prophecy + Curios. Right wing: Necropolis + draw piles.
export const SEAT = {
  // FOUR rifts, left to right, matching ESCLING_SLOTS in rules.js and the
  // 2D board's index order: Body(0), Sol(1), Heart(2), Mind(3). The x values
  // are ±2.325 / ±0.775 — an even 1.55 pitch kept symmetric about x = 0, so
  // the battle line stays centred on the seam now that a fourth rift exists.
  // The row spans 4.65 of the 13.2-wide TABLE plate, so nothing else on the
  // seat has to shrink and the wings (prophecy/necropolis at ±3.3) still clear
  // the outer rifts by more than a card's width.
  esclings: [
    [-2.325, 0, 1.05], // 0 — Body
    [-0.775, 0, 1.05], // 1 — Sol
    [0.775, 0, 1.05],  // 2 — Heart
    [2.325, 0, 1.05],  // 3 — Mind
  ],
  tomes: [
    [-1.55, 0, 2.55],
    [0.0, 0, 2.55],
    [1.55, 0, 2.55],
  ],
  prophecy: [-3.3, 0, 1.05],
  // SHIP 2 — corrected to the 2D reference: curios FLANK the tome row…
  curios: [
    [-3.3, 0, 2.55],
    [3.3, 0, 2.55],
  ],
  necropolis: [3.3, 0, 1.05],
  // SHIP 8.4 — THE EXILE RIFT (R112, "beside the Necropolis"). The 3D
  // board had no rift for it from the day the wave landed (2026-09-06);
  // the 2D tile sat next to the Necropolis the whole time. Outside the
  // graves, inside the table's edge (±6.6), clear of the Grimoire pile
  // at z 4.25.
  exile: [4.9, 0, 1.05],
  // …and the draw piles live at the hand: LUX left, GRIM right.
  grimoire: [4.9, 0, 4.25],
  luxmoire: [-4.9, 0, 4.25],

  // My hand fans just off the table edge, raised and tilted at the camera.
  handZ: 4.5,
  handY: 0.55,

  // Seat name-plate anchor (Html label).
  plate: [-5.7, 0.25, 3.35],
};

// ── CAMERA PRESETS — goal positions for the rig ──
export const CAM = {
  table: { pos: [0, 10.5, 9.0], tgt: [0, 0, 0.4] },
  mine: { pos: [0, 6.2, 7.6], tgt: [0, 0, 2.0] },
  theirs: { pos: [0, 7.2, 4.8], tgt: [0, 0, -2.2] },
  // SHIP 2 — the cinematic: low side-on shot straight down the seam.
  duel: { pos: [9.2, 2.6, 0.2], tgt: [0, 0.5, 0] },
};
